import FJVideoSettingsContainer from '../FJVideoSettings/FJVideoSettingsContainer';
import PropTypes from 'prop-types';
import FJConstant from '../../../constants/FJConstant';
import FJUrlToVideoStartContainer from '../FJUrlToVideoStart/FJUrlToVideoStartContainer';
import FJUrlToVideoScriptEditContainer from '../FJUrlToVideoScriptEdit/FJUrlToVideoScriptEditContainer';
import FJDisplayPanel from '../FJDisplayPanel/FJDisplayPanel';
const FJBlogUrlToVideo = props => {
    const { textToVideoStep } = props;
    return (
        <>
            <FJDisplayPanel active={textToVideoStep === FJConstant.STEP_TYPE_HOME}>
                <FJUrlToVideoStartContainer />
            </FJDisplayPanel>
            <FJDisplayPanel active={textToVideoStep === FJConstant.STEP_TYPE_SCRIPTS_EDIT}>
                <FJUrlToVideoScriptEditContainer />
            </FJDisplayPanel>
            <FJDisplayPanel active={textToVideoStep === FJConstant.STEP_TYPE_VIDEO_SETTINGS}>
                <FJVideoSettingsContainer />
            </FJDisplayPanel>
        </>
    );
};

FJBlogUrlToVideo.propTypes = {
    textToVideoStep: PropTypes.string,
};

export default FJBlogUrlToVideo;
